import React from 'react';

const TooltipComponent = ({ 
  text, 
  width = '334px', 
  height = '32px',
  position = 'right-0',
  className = '',
  ...props 
}) => {
  return (
    <div
      className={`absolute z-[5] mb-2 bottom-full ${position} ${className}`}
      style={{
        width: width,
        height: height,
        borderRadius: '6px',
        paddingTop: '6px',
        paddingRight: '8px',
        paddingBottom: '6px',
        paddingLeft: '8px',
        background: '#1F2937',
        fontFamily: 'Inter',
        fontWeight: '400',
        fontSize: '13.56px',
        lineHeight: '20px',
        color: '#D1D5DB',
        whiteSpace: 'nowrap',
      }}
      {...props}
    >
      {text}
    </div>
  );
};

export default TooltipComponent;
